import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "knife-21", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 21 21", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("path", { fill: "currentColor", d: "M18.33 16.084s-1.954 2.16-4.398 3.24c-2.443 1.081-2.932.541-2.932.541l5.13-5.67 2.69-2.974a.647.647 0 0 1 .976.002c.272.3.271.781.002 1.079l-2.445 2.702.977 1.08z" }));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
